import {Trans} from '@lingui/macro'
import type {MouseEventHandler} from 'react'
import type React from 'react'

import config from 'config'
import type {PlanType} from '~/api/types/plan'
import tracking from '~/tracking'

import {ModalLink} from '../modal-choose-plans.styles'

interface FallbackAdditionalPricingProps {
    planType?: PlanType
}

export const FallbackAdditionalPricing: React.FC<FallbackAdditionalPricingProps> = ({planType}) => {
    const pricingURL = `${config.endpoints.commercial}/pricing`
    const fallbackNeedMoreClicked: MouseEventHandler<HTMLButtonElement> = () => {
        tracking.pricingEnquiryLinkActioned({
            //eslint-disable-next-line string-to-lingui/missing-lingui-transformation
            location: `${planType} plan user limit`,
            destination: pricingURL,
            source: window.location.href,
        })
    }

    return (
        <ModalLink
            href={`${pricingURL}#additional-users`}
            target="_blank"
            onClick={fallbackNeedMoreClicked}
            data-testid="fallback-additional-pricing"
        >
            <Trans>Need more?</Trans>
        </ModalLink>
    )
}
